export const VUEX_UI_EXPAND_GLOBAL_UPLOADER = 'VUEX_UI_EXPAND_GLOBAL_UPLOADER'
export const VUEX_UI_HIDE_GLOBAL_UPLOADER = 'VUEX_UI_HIDE_GLOBAL_UPLOADER'
export const VUEX_UI_MINIMIZE_GLOBAL_UPLOADER = 'VUEX_UI_MINIMIZE_GLOBAL_UPLOADER'
export const VUEX_UI_COLLAPSE_GLOBAL_UPLOADER = 'VUEX_UI_COLLAPSE_GLOBAL_UPLOADER'
